import { breakpointSize } from "../../../theme/mediaQuerie";
import Typography from "../../shared/typography/Typography";

const isMobile = window.innerWidth <= breakpointSize.Sm;

export const Subtitle = ({children}: {children: string}) => {
  return (
    <Typography type={isMobile ? "labelS" : "labelL"} color="title" >
      {children.charAt(0).toUpperCase() + children.slice(1)}
    </Typography>
  );
}